<div class="spinner" *ngIf="isLoading; else myInsurance"></div>
<ng-template #myInsurance>
  <!-- Coverage Cards - Endsleigh cover, international student cover -->
  <ng-container
    *ngIf="
      !noCoverOrProducts || userInsuranceProducts.length !== 0;
      else noCover
    "
  >
    <ng-container *ngFor="let card of coverageCards">
      <div
        *ngIf="card.show_card"
        class="my-insurance"
        [class.is-card-height]="card.international_student_card"
      >
        <div class="left-section">
          <h2>
            {{ card.title }}
          </h2>
          <div class="right-section">
            <p class="bold">
              {{ card.body }}
            </p>
          </div>
        </div>

        <button class="button" [routerLink]="card.cta_route">
          {{ card.cta_text }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noCover>
    <div class="my-insurance no-border" *ngFor="let card of coverageCards">
      <div class="left-section">
        <h2>
          {{ card.title }}
        </h2>
        <div class="right-section">
          <p class="bold">
            {{ card.body }}
          </p>
        </div>
      </div>

      <button class="button" [routerLink]="card.cta_route">
        {{ card.cta_text }}
      </button>
    </div>
  </ng-template>

  <!-- Other insurance projects -->
  <ng-container *ngIf="userInsuranceProducts.length !== 0">
    <ng-container *ngFor="let insurance of userInsuranceProducts">
      <div class="my-insurance">
        <div class="left-section">
          <div class="">
            <ng-template #showDescription
              >{{ insurance.product.description }}
            </ng-template>
          </div>
          <h2>
            {{
              insurance.product.productName
                ? insurance.product.productName
                : insurance.product.description
            }}
          </h2>
          <p>
            {{ insurance.product.description }}
          </p>
        </div>
        <button class="button">
          <a href="{{ insurance.product.linkURL }}"> View My Insurance </a>
        </button>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
